export default "__VITE_ASSET__D5V4_L7W__"